import { DateTime } from '@aibees/shared/components';
import { MemberStatus, MemberType } from '@aibees/shared/definition';
import {
  classnames,
  DATE_FORMAT_YYYY_MM_DD_hh_mm_a,
} from '@aibees/shared/utils';
import { useWorkspace } from '@aibees/shared/workspace';
import { memo } from 'react';
import { InlineInfoBox } from '../../../components/inline-info-box';
import * as Styled from './styles';
import * as SX from './sx';
import type { TeamMemberJoinedProps as Props } from './types';

export const TeamMemberJoined = memo(({ className, item }: Props) => {
  const workspace = useWorkspace();
  const isTransferPending =
    item.type === MemberType.Owner &&
    workspace?.transfer?.status === MemberStatus.Pending;

  return (
    <Styled.Wrapper
      className={classnames('TeamMemberJoined', className)}
      sx={SX.root}
    >
      {(item.status === MemberStatus.Active ||
        item.status === MemberStatus.disable) &&
        !isTransferPending && (
          <DateTime
            value={item.created}
            tooltipFormat={DATE_FORMAT_YYYY_MM_DD_hh_mm_a}
          />
        )}
      {item.status == MemberStatus.Pending && (
        <InlineInfoBox item={item} type="pending-invite" />
      )}
      {isTransferPending && (
        <InlineInfoBox item={item} type="pending-transfer-ownership" />
      )}
    </Styled.Wrapper>
  );
});

TeamMemberJoined.displayName = 'TeamMemberJoined';
